import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const SIAForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent; // UMS red accent

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        SIA Configuration
      </Typography>

      <Grid container spacing={2}>
        {/* API URL */}
        <Grid item xs={12} md={6}>
          <TextField
            label="API URL"
            fullWidth
            value={config.apiUrl || ""}
            onChange={(e) => onChange("apiUrl", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Auth Token */}
        <Grid item xs={12} md={6}>
          <TextField
            label="Auth Token"
            fullWidth
            value={config.authToken || ""}
            onChange={(e) => onChange("authToken", e.target.value)}
            variant="outlined"
            type="password"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SIAForm;
